import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import RoutesApp from '../../routes';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Estilos
import right_arrow from '../../assets/imgs/next.png';

//Componentes
import UsersWaitingValidation from './UsersWaitingValidation';

function UsersWaitingValidationContainer() {
    const { user, usersForHabilitation } = useGlobalContext();
    // const usersForValidation = JSON.parse(
    //     window.sessionStorage.getItem('usersWaitingHabilitation')
    // )
    //     ? JSON.parse(window.sessionStorage.getItem('usersWaitingHabilitation'))
    //     : [];
    // const [usersWaitingValidation, setUsersWaitingValidation] =
    //     useState(usersForValidation);

    const buildTableData = (data) => {
        return {
            headers: ['Nombre', 'Apellido', 'Teléfono', 'Correo', ' '],
            pagination: 10,
            data: data?.map((u) => {
                return {
                    nombre: u.nombre,
                    apellido: u.apellido,
                    telefono: u.celular,
                    correo: u.correo,
                    icons: (
                        <div>
                            <Link
                                to={RoutesApp.Profile + u.id}
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={right_arrow}
                                    title="Visualizar"
                                    alt="Visualizar"
                                />
                            </Link>
                        </div>
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(
        buildTableData(usersForHabilitation)
    );

    return <UsersWaitingValidation tableData={tableData} />;
}

export default UsersWaitingValidationContainer;
